"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const dateToEpochSeconds_1 = __importDefault(require("../utils/dateToEpochSeconds"));
function isBeforeExistingLastSession(existingStats, session) {
    if (!(typeof (existingStats === null || existingStats === void 0 ? void 0 : existingStats.lastStudied) === 'number'))
        return false;
    return (0, dateToEpochSeconds_1.default)(session.timeFinished) < existingStats.lastStudied;
}
exports.default = isBeforeExistingLastSession;
